import { Controller } from "@hotwired/stimulus"
import { KTToast } from "@keenthemes/ktui"

export default class extends Controller {
  static values = { variant: String, message: String }

  connect() {
    if (this.hasVariantValue && this.hasMessageValue) {
      KTToast.show({
        variant: this.variantValue === "alert" ? "destructive" : "success",
        message: this.messageValue,
      })
    }
  }

  disconnect() {
    KTToast.clearAll()
  }
}
